import { fetchWrapper } from '@/helpers'
const ruta = process.env.VUE_APP_ROOT_API

export default class ObjetivoComisionService {
  async datosNecesarios() {
    return await fetchWrapper.get(`${ruta}/objetivo-comisiones/datos-necesarios`)
  }
  async getAll(params = {}) {
    const q = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ''))
    ).toString()
    return await fetchWrapper.get(`${ruta}/objetivo-comisiones?${q}`)
  }
  async store(datos) {
    return await fetchWrapper.post(`${ruta}/objetivo-comisiones`, datos)
  }
  async update(datos) {
    return await fetchWrapper.put(`${ruta}/objetivo-comisiones/${datos.id}`, datos)
  }
  async destroy(id) {
    return await fetchWrapper.delete(`${ruta}/objetivo-comisiones/${id}`)
  }
  async avance(id) {
    return await fetchWrapper.get(`${ruta}/objetivo-comisiones/${id}/avance`)
  }
  async liquidar(id) {
    return await fetchWrapper.post(`${ruta}/objetivo-comisiones/${id}/liquidar`)
  }
  async copiar(id) {
    return await fetchWrapper.post(`${ruta}/objetivo-comisiones/${id}/copiar`)
  }
}